// Где живёт витрина: на общем домене или на домене клиента.
//
// На общем домене один origin на все магазины, и магазин задан первым сегментом
// пути (`/slug/c/12`). На домене клиента магазин один, и его задаёт сам хост —
// бэкенд принимает и слаг, и домен в один и тот же параметр пути, поэтому
// ничего, кроме этого модуля, о разнице знать не должно.
const SHARED_HOSTS = [
  'mypricelist.com.ua',
  'www.mypricelist.com.ua',
  'localhost',
  '127.0.0.1'
]

export const onSharedDomain = SHARED_HOSTS.indexOf(window.location.hostname) !== -1

// Берётся при загрузке страницы, а не из роутера: переход между магазинами —
// это всегда новая загрузка, внутри SPA ссылок на чужой магазин нет.
export function currentShop(): string {
  if (!onSharedDomain) {
    return window.location.hostname
  }
  return window.location.pathname.split('/')[1] || ''
}

// Внутренняя ссылка витрины: на общем домене с префиксом магазина, на своём
// домене — сразу от корня.
export function shopPath(suffix: string = ''): string {
  if (onSharedDomain) {
    return `/${currentShop()}${suffix}`
  }
  return suffix || '/'
}
